// extracted by mini-css-extract-plugin
export default {"header":"styles_header__nILKm","borderBottomBar":"styles_borderBottomBar__zC17h","innerHeader":"styles_innerHeader__GVQOT","logo":"styles_logo__LkFnK"};